var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_268_221426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 25.5H0V23.5C0 14.675 7.17505 7.5 16 7.5C24.825 7.5 32 14.675 32 23.5V25.5ZM1.33325 24.1667H30.6667V23.5C30.6667 15.4167 24.0833 8.83325 16 8.83325C7.91675 8.83325 1.33325 15.4167 1.33325 23.5V24.1667Z",
    fill: "#8694A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9319 17.2881L22.8748 18.231L18.3552 22.7505L17.4124 21.8076L21.9319 17.2881Z",
    fill: "#8694A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 24.8333H26.6667V23.5C26.6667 17.6167 21.8833 12.8333 16 12.8333C10.1167 12.8333 5.33325 17.6167 5.33325 23.5V24.8333H4V23.5C4 16.8833 9.3833 11.5 16 11.5C22.6167 11.5 28 16.8833 28 23.5V24.8333Z",
    fill: "#8694A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 24.8333H18V24.1667C18 23.0667 17.1001 22.1667 16 22.1667C14.8999 22.1667 14 23.0667 14 24.1667V24.8333H12.6667V24.1667C12.6667 22.325 14.1584 20.8333 16 20.8333C17.8416 20.8333 19.3333 22.325 19.3333 24.1667V24.8333Z",
    fill: "#8694A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 8.16675H16.6667V12.1667H15.3333V8.16675Z",
    fill: "#8694A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7021 12.5254L27.645 13.4683L24.8167 16.2966L23.8738 15.354L26.7021 12.5254Z",
    fill: "#8694A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30176 12.5215L8.13013 15.3499L7.18726 16.2927L4.35889 13.4644L5.30176 12.5215Z",
    fill: "#8694A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_268_221426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.b71c1aa8cf91a72345221946758a3a0d.svg";
export { ForwardRef as ReactComponent };